//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/GeometricUtilities.js";
import "../no/TaggedObject.js";
import "../GeometricUtilities/GeometricUtilities.HorizontalReference.js";
import "../no/SelectNXObject.js";
import "../GeometricUtilities/GeometricUtilities.DistancePatternSpacing.js";
import "../no/SelectObject.js";
let d=[[[0,"CreateLastStaggered",1,0],[1,"HorizontalRef",0,"GeometricUtilities.HorizontalReference",0],[0,"SimplifiedLayoutType",1,0],[0,"StaggerType",1,0],[0,"UseYDirectionToggle",1,0],[0,"XDirection",1,"Direction",0],[0,"XFlip",1,0],[1,"XSelection",0,"SelectNXObject",0],[1,"XSpacing",0,"GeometricUtilities.DistancePatternSpacing",0],[0,"XSymmetryToggle",1,0],[0,"YDirection",1,"Direction",0],[0,"YFlip",1,0],[1,"YSelection",0,"SelectNXObject",0],[1,"YSpacing",0,"GeometricUtilities.DistancePatternSpacing",0],[0,"YSymmetryToggle",1,0]],[[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.GeometricUtilities.RectangularPattern = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.GeometricUtilities.RectangularPattern";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.GeometricUtilities.RectangularPattern.StaggerOptions = Object.freeze({
    "None" : "None", "Row" : "Row", "Column" : "Column"});

SPLM.GeometricUtilities.RectangularPattern.SimplifiedLayoutTypes = Object.freeze({
    "Square" : "Square", "Triangle" : "Triangle", "Diamond" : "Diamond"});

export default SPLM;